<form
    [formGroup]="variantsForm"
    #ngForm="ngForm"
    name="watch-product-selector"
    class="watch-product-selector watch-product-selector-new-size-selector"
    [class.background-opacity]="productPageFacade.isProductPageRevampEnabled"
    [attr.method]="'post'">
    <span
        hSrOnlyNoSnippet
        role="heading"
        i18n-role
        aria-level="3"
        i18n="@@hermes.accessibility.product-customizer-title">
        Customization and add to cart
    </span>

    <!-- Watch size selection-->
    @if (product?.variants?.watchSizes) {
    <h-expansion-panel
        [role]="'accordion'"
        [expansionPanelId]="'watch-size-variants'"
        [collapsed]="toggleVariantCollapsed.watchSize"
        (collapsedChange)="onExpand($event, 'watchSize')"
        [borderBottomRemoved]="toggleVariantCollapsed.watchSize"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        [hasExpansionPanelIcon]="true"
        [contentPadding]="'15px 10px'"
        class="watch-expansion-panel">
        <ng-template [hExpansionPanelPart]="'header'">
            <ng-container i18n="@@hermes.product-page.watch-case-size"> Case size </ng-container>
        </ng-template>
        <ng-template [hExpansionPanelPart]="'expansionPanel'">
            @if (product.simpleAttributes?.modelSize) {
            <div class="expansion-panel-text paragraph-medium">
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.comma-separator">,&nbsp; </span>
                {{ product.simpleAttributes.modelSize }}
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
            </div>
            }
        </ng-template>

        <!-- Size guide -->
        <ng-template [hExpansionPanelPart]="'content'">
            <div>
                <ng-container *ngTemplateOutlet="sizeGuide"> </ng-container>
                <div class="variants-box" [attr.role]="'list'">
                    @for (variant of product?.variants?.watchSizes; track trackBySku(idx, variant); let idx = $index) {
                    <h-variant-item
                        [attr.role]="'listitem'"
                        [variant]="variant"
                        [currentProduct]="product"
                        [variantType]="'size'"
                        [allVariantsOutOfStock]="variant.sku === product.sku && areAllWatchColorVariantsOOS"
                        [formGroup]="variantsForm"
                        [formName]="'watchSizes'"
                        [inputId]="'watch-size-variant-item-' + variant.size | sanitize"
                        [selectedValue]="variantsForm.value.watchSizes"
                        id="size {{ idx }}"
                        [boxType]="product.sku === variant.sku ? 'none' : 'link'">
                    </h-variant-item>
                    }
                </div>
            </div>
        </ng-template>
    </h-expansion-panel>
    }

    <!-- Strap colors selection-->
    @if (product?.variants?.strapColors) {
    <h-expansion-panel
        [role]="'accordion'"
        [expansionPanelId]="'strap-color-variants'"
        [collapsed]="toggleVariantCollapsed.strapColor"
        (collapsedChange)="onExpand($event, 'strapColor')"
        [borderBottomRemoved]="toggleVariantCollapsed.strapColor"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        [hasExpansionPanelIcon]="true"
        [contentPadding]="'15px 10px'"
        class="watch-expansion-panel">
        <ng-template [hExpansionPanelPart]="'header'">
            {{ product.simpleAttributes?.strapLabel }}
        </ng-template>
        <ng-template [hExpansionPanelPart]="'expansionPanel'">
            @if (product.simpleAttributes?.strapValue) {
            <div class="expansion-panel-text paragraph-medium">
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.comma-separator">,&nbsp;</span>
                {{ product.simpleAttributes.strapValue | hSlashSpacer }}
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
            </div>
            }
        </ng-template>
        <ng-template [hExpansionPanelPart]="'content'">
            <div class="colors-variants-box" [attr.role]="'list'">
                @for (variant of product?.variants?.strapColors; track trackBySku(idx, variant); let idx = $index) {

                <h-variant-item
                    id="color {{ idx }}"
                    [attr.role]="'listitem'"
                    [boxType]="product.sku === variant.sku ? 'none' : 'link'"
                    [currentProduct]="product"
                    [variant]="variant"
                    [imageSrc]="variant.image"
                    [variantType]="'color'"
                    [formGroup]="variantsForm"
                    [formName]="'strapColors'"
                    [inputId]="'strap-color-variant-item-' + variant.refColoris + '-' + variant.nbTours | sanitize"
                    [selectedValue]="{ nbTours: variant.nbTours, refColoris: variant.refColoris } | json">
                </h-variant-item>

                }
            </div>
        </ng-template>
    </h-expansion-panel>
    }

    <!-- Strap length selection -->
    @if (product?.variants?.strapLengths) {
    <h-expansion-panel
        [role]="'accordion'"
        [expansionPanelId]="'strap-length-variants'"
        [contentPadding]="'15px 10px'"
        [collapsed]="toggleVariantCollapsed.strapLength"
        (collapsedChange)="onExpand($event, 'strapLength')"
        [borderBottomRemoved]="shouldRemoveBottomBorderForStraps()"
        [backgroundColor]="
            productPageFacade.isProductPageRevampEnabled && !isMobile ? transparentColor : secondaryColorLight
        "
        [hasExpansionPanelIcon]="true"
        class="watch-expansion-panel">
        <ng-template [hExpansionPanelPart]="'header'">
            {{ product.simpleAttributes?.wristCircumferenceLabel }}
        </ng-template>
        <ng-template [hExpansionPanelPart]="'expansionPanel'">
            @if (product.simpleAttributes?.wristCircumferenceValue) {
            <span class="expansion-panel-text paragraph-medium" [attr.role]="'text'">
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.comma-separator">,&nbsp; </span>
                {{ product.simpleAttributes.wristCircumferenceValue }}
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected"> selected </span>
            </span>
            }
        </ng-template>

        <!-- Size guide -->
        <ng-template [hExpansionPanelPart]="'content'">
            <div>
                <ng-container *ngTemplateOutlet="sizeGuide"> </ng-container>
                <div class="aligned-variants-box" [attr.role]="'list'">
                    @for (variant of product?.variants?.strapLengths; track trackBySku(idx, variant); let idx = $index)
                    {
                    <h-variant-item
                        [attr.role]="'listitem'"
                        [variant]="variant"
                        [currentProduct]="product"
                        [variantType]="'size'"
                        [formGroup]="variantsForm"
                        [formName]="'strapLengths'"
                        [inputId]="'strap-length-variant-item-' + variant.size | sanitize"
                        [selectedValue]="variantsForm.value.strapLengths"
                        id="size {{ idx }}"
                        [boxType]="product.sku === variant.sku ? 'none' : 'link'">
                    </h-variant-item>
                    }
                </div>
            </div>
        </ng-template>
    </h-expansion-panel>
    } @if ( (product.attributes.shippingInformation && !product.stock.shared && !toggleVariantCollapsed.strapLength) ||
    product.stock.shared ) {
    <h-separator [lightColor]="true"></h-separator>
    }
    <h-product-delivery-details
        [product]="product"
        [shippingInformation]="product.attributes.shippingInformation"></h-product-delivery-details>
    <h-separator [lightColor]="true"></h-separator>
    <h-call-to-action-purchase
        [addToCartButtonIsDisplayed]="isAddToCartButtonDisplayed"
        [product]="product"
        [transparentBackground]="productPageFacade.isProductPageRevampEnabled"
        (addToCart)="addToCartAction($event)">
    </h-call-to-action-purchase>

    @if (product.stock.retail) {
    <h-call-to-action-find-in-store
        [product]="product"
        [skus]="[product.sku]"
        [transparentBackground]="productPageFacade.isProductPageRevampEnabled">
    </h-call-to-action-find-in-store>
    }
</form>

<!-- Size guide template -->
<ng-template #sizeGuide
    ><div class="size-container">
        <h-call-to-action-size-guide [product]="product" [withPaddingBottom]="true"> </h-call-to-action-size-guide>
    </div>
</ng-template>
